<div class="wrap">
    <app-banner></app-banner>
    <app-about-us></app-about-us>
</div>


